// extracted by mini-css-extract-plugin
export default {"Box_0":"VisibleItem-module__Box_0__NHNWDns"};